export const appToDo = "IAa";
export default {appToDo};